@if (!summary) {
  <mat-form-field class="w-100">
    <mat-label [innerHtml]="question.editLabel | localized"></mat-label>
    <input type="text"
      matInput
      [readOnly]="summary"
      [formControl]="control"
      [value]="control?.value"
      [required]="question.isRequired"
      [id]="question.questionNumber">
      @if (!control.valid) {
        <mat-error>
          {{'form.validation.required' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }

  @if (summary) {
    <p class="summary">
      <label [innerHtml]="question.summaryLabel | localized"> : </label>
      @if (!!control.value) {
        <span>{{ control.value}}</span>
      }
      @if (!control.value) {
        <span class="notFilled">N/A</span>
      }
    </p>
  }
